import { getString } from "../../common/common";

export const KS_CLICK_HERE = "KS_CLICK_HERE";
export const KS_HEADING1 = "KS_HEADING1";
export const KS_HEADING2 = "KS_HEADING2";
export const KS_HEADING3 = "KS_HEADING3";
export const DEPOTS = "DEPOTS";
export const DIVISIONS = "DIVISIONS";
export const BUS_STATIONS = "BUS_STATIONS";
export const VEHICLES = "VEHICLES";
export const SCHEDULES = "SCHEDULES";
export const EFFECTIVE_KM_PER_DAY = "EFFECTIVE_KM_PER_DAY";
export const ITALY = "ITALY";
export const AVG_TRA_REV_PER_DAY = "AVG_TRA_REV_PER_DAY";
export const LAKH = "LAKH";
export const AVG_PASS_TRA_PER_DAY = "AVG_PASS_TRA_PER_DAY";
export const STAFF = "STAFF";
export const STAFF_RATION_PER_SCHE = "STAFF_RATION_PER_SCHE";

export const translations = {
  en: {
    [KS_CLICK_HERE]: "Click Here",
    [KS_HEADING1]: "Updated Information is published on ksrtc.karnataka.gov.in",
    [KS_HEADING2]: "to View",
    [KS_HEADING3]: "KSRTC Key Statistics (Month of Dec-2020)",
    [DEPOTS]: "Depots",
    [DIVISIONS]: "Divisions",
    [BUS_STATIONS]: "Bus stations",
    [VEHICLES]: "Vehicles",
    [SCHEDULES]: "Schedules",
    [EFFECTIVE_KM_PER_DAY]: "Effective Kms per day",
    [ITALY]: "Italy",
    [AVG_TRA_REV_PER_DAY]: "Average traffic revenue per day",
    [LAKH]: "lakh",
    [AVG_PASS_TRA_PER_DAY]: "Average passengers travelled per day",
    [STAFF]: "Staff",
    [STAFF_RATION_PER_SCHE]: "Staff ratio per schedule",
  },
  kn: {
    [KS_CLICK_HERE]: "ಕ್ಲಿಕ್ ಮಾಡಿ",
    [KS_HEADING1]:
      "ಅಪ್‌ಡೇಟ್ ಮಾಡಿದ ಮಾಹಿತಿಯನ್ನು ksrtc.karnataka.gov.in ನಲ್ಲಿ ಪ್ರಕಟಿಸಲಾಗಿದೆ ನೋಡಲು ಇಲ್ಲಿ",
    [KS_HEADING2]: "",
    [KS_HEADING3]: "KSRTC ಪ್ರಮುಖ ಅಂಕಿಅಂಶಗಳು (ಡಿಸೆಂಬರ್ ತಿಂಗಳು-2020)",
    [DEPOTS]: "ಡಿಪೋಗಳು",
    [DIVISIONS]: "ವಿಭಾಗಗಳು",
    [BUS_STATIONS]: "ಬಸ್ ನಿಲ್ದಾಣಗಳು",
    [VEHICLES]: "ವಾಹನಗಳು",
    [SCHEDULES]: "ವೇಳಾಪಟ್ಟಿಗಳು",
    [EFFECTIVE_KM_PER_DAY]: "ದಿನಕ್ಕೆ ಪರಿಣಾಮಕಾರಿ ಕಿ.ಮೀ",
    [ITALY]: "ಇಟಲಿ",
    [AVG_TRA_REV_PER_DAY]: "ದಿನಕ್ಕೆ ಸರಾಸರಿ ಸಂಚಾರ ಆದಾಯ",
    [LAKH]: "ಲಕ್ಷ",
    [AVG_PASS_TRA_PER_DAY]: "ದಿನಕ್ಕೆ ಸರಾಸರಿ ಪ್ರಯಾಣಿಕರು ಪ್ರಯಾಣಿಸುತ್ತಾರೆ",
    [STAFF]: "ಸಿಬ್ಬಂದಿ",
    [STAFF_RATION_PER_SCHE]: "ಪ್ರತಿ ವೇಳಾಪಟ್ಟಿಗೆ ಸಿಬ್ಬಂದಿ ಅನುಪಾತ",
  },
};

export const t = (key = "") => {
  return getString(key, translations);
};
